import { render } from "./realNameDetail.vue?vue&type=template&id=a370a0cc&scoped=true"
import script from "./realNameDetail.vue?vue&type=script&lang=js"
export * from "./realNameDetail.vue?vue&type=script&lang=js"

import "./realNameDetail.vue?vue&type=style&index=0&id=a370a0cc&scoped=true&lang=less"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a370a0cc"]])

export default __exports__